const AttentionIcon = ({
  width = "16px",
  height = "16px",
}: {
  width?: string;
  height?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="icon-attention"
  >
    <g id="Group36">
      <path
        id="Vector"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#F3A61C"
      />
      <path
        id="Vector_2"
        d="M8 4V9"
        stroke="#373738"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        id="Vector_3"
        d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
        fill="#373738"
      />
    </g>
  </svg>
);

export default AttentionIcon;
